import {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import {Paper} from '@material-ui/core';
import {registration} from 'App/api';
import SelectField from 'App/formComponents/fields/select';
import ShipwellLoader from 'App/common/shipwellLoader/index';
import {upsServiceOptions} from 'App/utils/parcelConstants';
import ParcelRateList from 'App/components/parcelRateList';
import './styles.scss';

const UPSRates = (props) => {
  const {upsPackageTypes, packageType, numberOfPackages, rfq, quotes, handleSelectQuote, onAccountChange} = props;

  const [account, setAccount] = useState(null);
  const [accounts, setAccounts] = useState([]);

  const serviceLevels = upsServiceOptions.reduce((options, option) => {
    const {id, name} = option;
    return {...options, [id]: name};
  }, {});

  const getUPSRegistrationAccounts = async () => {
    try {
      const response = await registration.getUPSRegistrationAccounts();

      if (response && response.body && response.body.results.length) {
        setAccounts(response.body.results.map((account) => ({id: account.id, name: account.account_number})));
        setAccount(rfq && rfq.ups_specific_options && rfq.ups_specific_options.account);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleAccountChange = (selectedAccount) => {
    if (selectedAccount) {
      setAccount(selectedAccount);

      if (onAccountChange) {
        onAccountChange(selectedAccount, 'ups');
      }
    }
  };

  useEffect(() => {
    if (accounts.length < 1) {
      getUPSRegistrationAccounts();
    }
  }, []);

  return (
    <Paper className="ups-rates">
      <div className="paper__header">
        <img src="/images/ups_logo.svg" width="90" />
        <div>
          <label>UPS Account</label>
          <SelectField
            simpleValue
            value={account}
            placeholder="UPS Account"
            options={accounts}
            onChange={handleAccountChange}
          />
        </div>
      </div>

      {quotes && quotes.ups && quotes.ups.length > 0 && (
        <div className="ups-rates__table table__container">
          <ParcelRateList
            quotes={quotes.ups}
            serviceLevels={serviceLevels}
            packageType={packageType}
            packageTypes={upsPackageTypes}
            numberOfPackages={numberOfPackages}
            handleSelectQuote={handleSelectQuote}
            providerCode="UPS"
          />
        </div>
      )}

      {quotes && quotes.ups && quotes.ups.length < 1 && (
        <div className="paper__content text-center ">
          <div className="ups-rates__noResults">
            <h3>No rates available for this shipment.</h3>
          </div>
        </div>
      )}

      {(!quotes || !quotes.ups) && (
        <ShipwellLoader loading={!quotes || !quotes.ups} loadingText="Searching for quotes..." />
      )}
    </Paper>
  );
};

export default connect((state) => ({
  upsPackageTypes: state.shipments.upsPackageTypes.reduce(
    (types, type) => ({...types, [type.id]: `UPS ${type.label}`}),
    {}
  )
}))(UPSRates);
